var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",class:[
      _vm.classWrapper,
      {
        redesign: _vm.redesign,
        is_big: _vm.is_big,
        modal_rates: _vm.modal_rates,
        'is-sticky': _vm.isSticky,
        'is-white': _vm.isWhite,
        small: _vm.small
      }
    ]},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.close),expression:"close"}],staticClass:"modal-container"},[(_vm.showModalClose)?[(_vm.redesign)?_c('i',{staticClass:"modal__close icon icon-close",on:{"click":_vm.close}}):_c('a',{staticClass:"modal-close",on:{"click":_vm.close}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),(_vm.hasFooter)?_c('div',{staticClass:"modal-footer",class:{
            'modal-footer--left': _vm.footerAlign === 'left',
            'modal-footer--right': _vm.footerAlign === 'right'
          }},[_vm._t("footer",function(){return [_c('vbutton',{staticClass:"button-ok",attrs:{"label":"common.ok"},on:{"click":function($event){return _vm.$emit('close')}}})]})],2):_vm._e()],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }